import errorManager from '@/rollbar.js';

const init = () => {
  try {
    $('#form-guest-activity').on('ajax:success', function (e, data, status, xhr) {
      if (data.first_of_today) {
        if (confirm('Vuoi registrare pasto consumato?')) {
          $.ajax({
            url: '/' + window.locale + '/domestic_app/meal_detection/' + data.meal_activity_id,
            type: 'GET',
            success: function (result) {
              return alert('Pasto registrato correttamente');
            },
            error: function (result) {
              return alert('Errore: Pasto NON registrato correttamente');
            },
          });
        }
      }
    });
  } catch (e) {
    errorManager(e);
  }
};

window.SpotMealRegistration = {
  init: init,
};
